module.exports = __webpack_public_path__ + "static/media/concept2.04204dd2.mp4";